import type { RatingProps } from '@packages/shared';
import type { FC } from 'react';
import { Rating } from '../Rating';
import type { StackProps } from '../Stack';
import { Stack } from '../Stack';
import { Typography } from '../Typography';

export type RatingIconsProps = {
  /**
   * Average rating for a given product, ranging from 0 to 5 with a precision of 0.1.
   * */
  avgRating: RatingProps['value'];
  /**
   * Amount of given ratings.
   * */
  reviewCount: number;
  /**
   *The size of the component.
   *
   * @default medium
   */
  size?: RatingProps['size'];
} & StackProps;

/**
 * Shows RatingIcons and the amount of given ratings
 * */
export const RatingIcons: FC<RatingIconsProps> = ({
  avgRating,
  reviewCount,
  size = 'medium',
  ...stackProps
}) => (
  <Stack direction="row" alignItems="flex-end" gap={0.5} {...stackProps}>
    <Rating
      readOnly
      size={size}
      name="customized-color"
      value={avgRating}
      defaultValue={0}
      precision={0.1}
    />
    {reviewCount > 0 && (
      <Typography variant="body3" sx={{ color: 'text.dark', lineHeight: '1.27rem' }}>
        ({reviewCount})
      </Typography>
    )}
  </Stack>
);
